import React from "react";
import Box from "@mui/material/Box";
import TeamDetailProfile from "./TeamDetailProfile";

export default function TeamDetailHeaderBand({ team }) {
  return (
    <Box
      sx={{
        bgcolor: "#FFF",
        px: 3,
        pt: 2,
        pb: 2,
        borderBottom: "1px solid #E5E9EC",
        flexShrink: 0,
        overflow: "hidden",
        minWidth: 0,
      }}
    >
      <TeamDetailProfile team={team} />
    </Box>
  );
}
